document.addEventListener("DOMContentLoaded", function () {
  // @todo: replace by HTML Custom Element
  document.querySelectorAll(".comparison-tabs").forEach((section) => {
    const tabs = section.querySelectorAll(".comparison-tabs__tab");
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((currentTab, index) => {
          currentTab.classList.toggle(
            "comparison-tabs__tab--active",
            currentTab === tab
          );
          section
            .querySelector(`.comparison-tabs__grid:nth-child(${index + 1})`)
            .classList.toggle(
              "comparison-tabs__grid--active",
              currentTab === tab
            );
        });
      });
    });

    section.querySelectorAll(".comparison-tabs__grid").forEach((grid) => {
      const toggle = grid.querySelector(".comparison-tabs__toggle");
      let isDragging = false;
      let startX, currentX;

      const updateClipPath = (percentage) => {
        const item1 = grid.querySelector(
          ".comparison-tabs__grid-item:nth-child(1)"
        );
        const item2 = grid.querySelector(
          ".comparison-tabs__grid-item:nth-child(2)"
        );

        item1.style.clipPath = `polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0 100%)`;
        item2.style.clipPath = `polygon(${percentage}% 0, 100% 0, 100% 100%, ${percentage}% 100%)`;
      };

      const handleDragStart = (e) => {
        isDragging = true;
        startX = e.type === "mousedown" ? e.pageX : e.touches[0].pageX;
        toggle.style.transition = "none";
      };

      const handleDrag = (e) => {
        if (!isDragging) return;

        e.preventDefault();
        currentX = e.type === "mousemove" ? e.pageX : e.touches[0].pageX;

        const rect = grid.getBoundingClientRect();
        const percentage = Math.min(
          Math.max(((currentX - rect.left) / rect.width) * 100, 0),
          100
        );

        toggle.style.left = `${percentage}%`;
        toggle.style.transform = "translateX(-50%)";
        updateClipPath(percentage);
      };

      const handleDragEnd = () => {
        isDragging = false;
        toggle.style.transition = "";
      };

      toggle.addEventListener("mousedown", handleDragStart);
      document.addEventListener("mousemove", handleDrag);
      document.addEventListener("mouseup", handleDragEnd);

      toggle.addEventListener("touchstart", handleDragStart);
      document.addEventListener("touchmove", handleDrag);
      document.addEventListener("touchend", handleDragEnd);
    });
  });
});
